jQuery(document).ready(function ($) {
    // Verificação dos campos do formulário
    $('#step-2 input').on('change keyup', function() {  
        let canSubmit = true;

        $('#step-2 input').each(function() {
            if($(this).attr('type') !== 'checkbox' && !$(this).val()) {
                canSubmit = false;
                return false; // Sai do loop each
            }
        });

        // Verifica o checkbox de consentimento separadamente
        if(canSubmit && !$('#billing-consent').is(':checked')) {
            canSubmit = false;
        }

        if(canSubmit) {
            $("#submit-quotation").removeClass('disabled');
        } else {
            $("#submit-quotation").addClass('disabled');
        }
    });
    
    aplicarCaixaAlta('#billing-name');

    $('#quotation-form').on('submit', function(e) {
        e.preventDefault();
        
        // Verifica se o botão está desabilitado
        if($("#submit-quotation").hasClass('disabled')) {
            return false;
        }

        let form = new FormData(e.target);
        
        let emailValido = validarEmail(form.get('email'));
        let nascimentoValido = validarDataNascimento(form.get('nascimento'));
        let nomeValido = validarNomeCompleto(form.get('nome'));
        
        if(emailValido == false){
            alert(`Domínio de e-mail não permitido. Por favor utilize outro endereço.`);
            $('#billing-email').addClass('erro-campo');
            return false;
        } else {
            $('#billing-email').removeClass('erro-campo');
        }

        if(nascimentoValido == false){
            $('#billing-birthday').addClass('erro-campo');
            $('label[for="billing-birthday"] .erro').show();    
            return false;
        } else {
            $('#billing-birthday').removeClass('erro-campo');
            $('label[for="billing-birthday"] .erro').hide();  
        }

        if(nomeValido == false){
            $('#billing-name').addClass('erro-campo');
            $('label[for="billing-name"] .erro').show();    
            return false;
        } else {
            $('#billing-name').removeClass('erro-campo');
            $('label[for="billing-name"] .erro').hide();   
        }

        $.ajax({
            url: 'https://nodejs.crpmango.com.br/shopify/create-customer',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                firstName: form.get('nome'),
                lastName: '',
                email: form.get('email'),
                phone: form.get('telefone'),
                nascimento: form.get('nascimento'),
                country: 'Brasil'
            }),
            beforeSend: function(){
                $('#submit-quotation').addClass('waiting');
                
                $('label[for="billing-email"] .erro').hide();    
                $('label[for="billing-phone"] .erro').hide();   
                $('#billing-email').removeClass('erro-campo'); 
                $('#billing-phone').removeClass('erro-campo'); 
            },
            success: function(response) {
                console.log('Cliente criado com sucesso:', response);
                $('#submit-quotation').removeClass('waiting');

                // Guarda esses dados no storage
                let data = JSON.stringify({
                    nome: form.get('nome'),
                    nascimento: form.get('nascimento'),
                    email: form.get('email'),
                    telefone: form.get('telefone'),
                    customer: response.customerId
                });
         
                sessionStorage.setItem('preAdesao', data);
                
                // Redireciona para a listagem de planos (URL fixa sem filtro de cidade)
                window.location.href = '/collections/planos-de-saude';

            },
            error: function(error) {
                $('#submit-quotation').removeClass('waiting');
                
                errorData = JSON.parse(error.responseText);
                console.log(errorData);

                switch (errorData.details[0].message) {
                    case "Phone has already been taken":
                        $('#billing-phone').addClass('erro-campo');
                        $('label[for="billing-phone"] .erro').show();
                        break; 
                    case "Email has already been taken":
                        $('#billing-email').addClass('erro-campo');
                        $('label[for="billing-email"] .erro').show();    
                        break;
                    default:
                        alert('Ocorreu um erro no formulário, tente novamente mais tarde.');
                        break;
                }
            }
        });
    });
});